module.exports = __webpack_public_path__ + "img/vehicle-info.fe374278.png";